import type { UserSalutation } from './userAccount';

export interface StorageboxData {
  city: StorageboxCities;
  salutation?: UserSalutation;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  description: string;
}

export interface IStorageboxContext {
  submitModel: (model: StorageboxData) => Promise<void>;
  state: StorageboxState | undefined;
}

export const STORAGE_BOX_LOCALIZATION_OPTS = [
  'Berlin Hohenschönhausen',
  'Berlin Lichtenberg-Marzahn',
  'Berlin Schöneweide-Köpenick',
  'Berlin Neukölln',
  'Berlin Spandau',
  'Bielefeld',
  'Pforzheim',
  'Chemnitz',
  'Dortmund Oespel',
  'Dortmund Innenstadt Ost',
  'Dresden Friedrichstadt',
  'Dresden Pieschen',
  'Düsseldorf Heerdt',
  'Düsseldorf Lierenfeld',
  'Essen',
  'Frankfurt',
  'Hannover List',
  'Hannover Vahrenwald',
  'Hannover Waldhausen',
  'Köln Ossendorf',
  'Köln Poll',
  'Krefeld',
  'Leipzig',
  'Leverkusen',
  'Mannheim',
  'Münster',
  'Stuttgart',
] as const;

export type StorageboxCities = (typeof STORAGE_BOX_LOCALIZATION_OPTS)[number];

export enum STORAGEBOX_SERVICE_STATUS {
  NOT_ACTIVATED = 'NOT_ACTIVATED',
  ACTIVATED = 'ACTIVATED',
}

export interface StorageboxState {
  status: STORAGEBOX_SERVICE_STATUS;
  plusProduct: boolean;
}

export type StorageboxStateMember<TType extends string> = {
  status: TType;
};
